import { WebPushSwitch } from "@/components/web-push/WebPushSwitch";
import { SoundNotificationSwitch } from "@/components/sound-notification/SoundNotificationSwitch";
import MediaAutoDownloadSettings from "./MediaAutoDownloadSettings";

/**
 * The Preferences settings body (web push / sound / media auto-download).
 * Rendered by PreferencesTab (legacy accordion) and SettingsCategoryView
 * (flag `settingsMiddleViews`). Carries its own inner padding div exactly as
 * the accordion version did.
 */
export default function PreferencesContent() {
  return (
    <div className="px-3">
      <WebPushSwitch />
      <div className="my-2 border-t border-border" />
      <SoundNotificationSwitch />
      <div className="my-2 border-t border-border" />
      <MediaAutoDownloadSettings />
    </div>
  );
}
